import React from "react"
import { IOptionalBoolParameterValue } from "../../models"
import { Chip, IconButton, FontIcon } from "material-ui"
import AddFilterTemplateOptionalBoolParameterDialog from "./AddFilterTemplateOptionalBoolParameterDialog"
import strings from "../../localization/strings"
import { checkPhaseFieldAvailable } from "../../helpers/punchHelper"
import AccountStore from "../../stores/AccountStore"

interface IProps {
    parameterNames: string[]
    useYesNoLabelparameterNames?: string[]
    optionalParameterValues: IOptionalBoolParameterValue[]
    handleChange(optionalParameterValues: IOptionalBoolParameterValue[]): void
}
interface IState {
    openAddFilterTemplateOptionalBoolParameterDialog: boolean
    editOptionalBoolParameter: IOptionalBoolParameterValue
}

export default class FilterTemplateOptionalBoolParametersChips extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddFilterTemplateOptionalBoolParameterDialog: false,
            editOptionalBoolParameter: null
        }
    }

    render() {
        return (
            <div>
                <div>{strings.Additional_Filter_Parameter}</div>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {this.props.optionalParameterValues.map(i => {
                        const useYesNo = this.props.useYesNoLabelparameterNames && this.props.useYesNoLabelparameterNames.includes(i.Name)
                        const name = strings[i.Name] === strings.RequirePhase ? checkPhaseFieldAvailable("singular") ? `Require ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings[i.Name]:  strings[i.Name]
                        return (
                            <Chip
                                key={i.Name}
                                style={{ margin: 5, cursor: "pointer" }}
                                onClick={() => this.setState({ openAddFilterTemplateOptionalBoolParameterDialog: true, editOptionalBoolParameter: i })}
                                onRequestDelete={() => this.props.handleChange(this.props.optionalParameterValues.filter(e => e.Name !== i.Name))}
                            >
                                {`${name}: ${i.Value ? useYesNo ? strings.Yes : strings.ON : useYesNo ? strings.No : strings.OFF}`}
                            </Chip>
                        )
                    })}
                    {this.props.parameterNames.length !== this.props.optionalParameterValues.length &&
                        <IconButton
                            style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => this.setState({ openAddFilterTemplateOptionalBoolParameterDialog: true, editOptionalBoolParameter: null })}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                </div>
                {this.state.openAddFilterTemplateOptionalBoolParameterDialog &&
                    <AddFilterTemplateOptionalBoolParameterDialog
                        parameterNames={this.props.parameterNames}
                        useYesNoLabelparameterNames={this.props.useYesNoLabelparameterNames}
                        editValue={this.state.editOptionalBoolParameter}
                        values={this.props.optionalParameterValues}
                        handleChange={this.props.handleChange}
                        handleClose={() => this.setState({ openAddFilterTemplateOptionalBoolParameterDialog: false, editOptionalBoolParameter: null })}
                    />
                }
            </div>
        )
    }
}